import { render, staticRenderFns } from "./LSpinningLoader.vue?vue&type=template&id=a8179c2a"
import script from "./LSpinningLoader.vue?vue&type=script&lang=ts"
export * from "./LSpinningLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports